import {
  Button,
  CircularProgress,
  withWidth
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
  AddRounded as AddRoundedIcon,
  Cancel as CancelIcon,
  Edit as EditIcon,
  Fullscreen as MaximiseIcon,
  FullscreenExit as MinimiseIcon,
  KeyboardArrowDown as ArrowDropDown,
  MailOutline as MailOutlineIcon,
  OpenInNew as UndockIcon,
  SaveAltSharp as SaveAltSharp,
  NoteAddOutlined as EditShipmentNoteIcon
} from "@material-ui/icons";
import React, { Fragment } from "react";
import Select from "react-select";
import { compose } from "recompose";
import appConstant from "../appConstants";
import { trackEvent } from "../components/common/AppInsightsEventTracking";
import MapDrawinToolBox from "../components/mapComponents/Drawing/DrawingToolbox";
import PickupsGridFilter from "../components/modules/Dispatch/RouteExecution/Pickups/Grid/Filter/GridFilter";
import { PICKUP_MANAGEMENT_MODES } from "../components/modules/Dispatch/RouteExecution/Pickups/PickupManagement/constants";
import { withUserProfile } from "../userProfile/userProfileContext";
import Tooltip from "./../components/common/StyledToolTip";
import { TextFieldEditor } from "./../components/dataGrid/cellEditors";
import { ToggleRenderer } from "./../components/dataGrid/cellRenderer";
import styles from "./componentHeaderStyles";
import PopInIcon from "./icons/PopIn";
import TSPIcon from "./icons/TSP";
import CancelDispatch from "./layoutHeader/components/CancelDispatch";
import CreateDispatch from "./layoutHeader/components/CreateDispatch";
import SearchBar from "./layoutHeader/components/SearchBar";
import EndTripIcon from "./layoutHeader/components/EndTrip";
import VoidPickup from "./layoutHeader/components/VoidPickup";
import PrintMenu from "./layoutHeader/printComponent";
import ShowHideColumns from "./layoutHeader/showHideColumns";
import EditPickup from "./layoutHeader/components/EditPickup";
import {withFeatureFlags} from "../userProfile/featureFlagsContext"
import MergePickup from "./layoutHeader/components/MergePickup";
import { csvFormulaInjectionSanitizer } from "../utilities/csvUtils";
import EquipmentDefects from "./layoutHeader/components/EquipmentDefects";
import MergeStops from "./layoutHeader/components/MergeStops";
import Revert from "./layoutHeader/components/Revert";
import SetAPT from "./layoutHeader/components/SetAPT";
import ClearAllFilterButton from "../components/dataGrid/columnFilters/ClearAllFilterButton";

class GLComponentHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMaximised: false,
      activeIndex: 0,
      headerIndex: this.props.stackIndex,
      enableMergeRoutes: false,
      enableTSP: false,
      showEditMode: false,
      enableEdit: false,
      enableCreatePickup: true,
      enableGeocode: false,
      isSaveButtonDisabled: false,
      isRouteAnimationEnabled: true,
      isMapLegendEnabled: false,
      updateMessage: null,
      showPrintLoadingManifest: false,
    };
    this.editorRef = {};
    this.headerConfig =
      this.props.stack.config.content[this.props.stackIndex].gridHeader || {};
    this.headerId = this.props.headerId;
    this.componentRef = React.createRef();
    this.isSubWindow = this.props.stack.layoutManager.isSubWindow;
    this.enableDispatchDriver = this.props.featureFlags.isFeatureEnabled(
      appConstant.features.EnableDispatchDriver
    );
    this.enablePickupEdit = this.props.featureFlags.isFeatureEnabled(
      appConstant.features.EnablePickupEdit
    );
    this.enableMergePickup = this.props.featureFlags.isFeatureEnabled(
      appConstant.features.EnableMergePickup
    );
  }

  componentDidMount() {
    if (this.headerConfig && this.headerConfig.showTSP) {
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_EnableTSP`,
        this.enableTSP
      );
    }
    if (this.headerConfig && this.headerConfig.showMergeRoutes) {
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_EnableMergeRoutes`,
        this.enableMergeRoutes
      );
    }

    if (this.headerConfig && this.headerConfig.showEdit) {
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_DisableEditSave`,
        this.disableEditSave
      );
      this.props.stack.layoutManager.eventHub.on(
        `${this.headerId}_showEditMode`,
        this.showEditMode
      );
    }

    this.props.stack.layoutManager.eventHub.on(
      `${this.headerId}_updateMessage`,
      this.updateMessage
    );
    this.props.stack.layoutManager.eventHub.on(
      `${this.headerId}_setGridApi`,
      this.setGridApi
    );
    this.props.stack.layoutManager.eventHub.on(
      `${this.headerId}_activateTab`,
      this.activeIndexChanged
    );
    this.props.stack.layoutManager.eventHub.on(
      "updatePrintManifestStatus",
      this.updateprintManifestStatus
    );
    this.props.stack.on("activeContentItemChanged", this.hideShowHeader);
  }

  componentWillUnmount() {
    if (this.headerConfig && this.headerConfig.showTSP) {
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_EnableTSP`,
        this.enableTSP
      );
    }
    if (this.headerConfig && this.headerConfig.showMergeRoutes) {
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_EnableMergeRoutes`,
        this.enableMergeRoutes
      );
    }
    if (this.headerConfig && this.headerConfig.showEdit) {
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_DisableEditSave`,
        this.disableEditSave
      );
      this.props.stack.layoutManager.eventHub.off(
        `${this.headerId}_showEditMode`,
        this.showEditMode
      );
    }

    this.props.stack.layoutManager.eventHub.off(
      `${this.headerId}_updateMessage`,
      this.updateMessage
    );
    this.props.stack.layoutManager.eventHub.off(
      `${this.headerId}_setGridApi`,
      this.setGridApi
    );
    this.props.stack.layoutManager.eventHub.off(
      `${this.headerId}_activateTab`,
      this.activeIndexChanged
    );
    this.props.stack.layoutManager.eventHub.off(
      "updatePrintManifestStatus",
      this.updateprintManifestStatus
    );
    this.props.stack.off("activeContentItemChanged", this.hideShowHeader);

    if (this.state.gridApi) {
      this.state.gridApi.removeEventListener(
        "selectionChanged",
        this.onGridSelectionChanged
      );
      this.state.gridApi.removeEventListener(
        "rowDataChanged",
        this.onGridSelectionChanged
      );
    }
  }

  activeIndexChanged = (configId) => {
    let contentItem = this.props.stack.contentItems[0];
    if (configId) {
      contentItem =
        this.props.stack.contentItems.find(
          (contentItem) => contentItem.config.id === configId
        ) || contentItem;
    }
    this.props.stack.setActiveContentItem(contentItem);
  };

  openMainMenu = (event) => {
    this.setState({ mainMenuAnchor: event.currentTarget });
  };

  closeMainMenu = () => {
    this.setState({ mainMenuAnchor: null });
  };

  hideShowHeader = (component) => {
    this.setState({
      activeIndex: component.parent.config.activeItemIndex,
      isMaximised: this.props.stack.isMaximised,
    });
  };

  setGridApi = (api) => {
    this.setState(
      {
        gridApi: api,
      },
      this.onGridSelectionChanged
    );
    api.addEventListener("selectionChanged", this.onGridSelectionChanged);
    api.addEventListener("rowDataChanged", this.onGridSelectionChanged); // needed when shipments are moved from UNRTD to other route i.e when grid becomes empty
  };

  onGridSelectionChanged = () => {
    const selectedRows = this.state.gridApi.getSelectedRows();
    let selectedRowCount = selectedRows.length;
    if (this.props.headerId.includes(appConstant.gridNames.RoutesGrid)) {
      selectedRowCount = this.state.gridApi
        .getSelectedRows()
        .filter(
          (route) => route.routeName !== appConstant.UNRTD_ROUTENAME
        ).length;
    }
    if (
      this.props.headerId.includes(appConstant.gridNames.DispatchPickupsGrid)
    ) {
      selectedRowCount = this.state.gridApi.getSelectedRows().length;
    }

    this.setState({
      enableEdit: Boolean(selectedRowCount),
      enableGeocode: selectedRowCount === 1,
    });
  };


  updateMessage = (message) => {
    this.setState({
      updateMessage: message,
    });
  };

  exportCSV() {
    if (!this.state.gridApi) {
      return;
    }
    const gridName =
      this.props.stack.config.content[this.props.stackIndex].title;
    const scenarioName = this.props.userData.userProfile.scenarioName;
    const columnIds = this.state.gridApi.columnController
      .getAllGridColumns()
      .reduce((columnKeys, column) => {
        if (column.colDef.headerName && column.visible || column.colDef.hideColumnInGridShowInCSV) {
          columnKeys.push(column.colId);
        }
        return columnKeys;
      }, []);
    let params = {
      fileName: `${gridName}_${scenarioName}.csv`,
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    this.state.gridApi.exportDataAsCsv(params);

    const userProfile = this.props.userData.userProfile;
    trackEvent("GridDataDownload", userProfile, { gridName });
  }

  enableTSP = (enableTSP) => {
    this.setState({
      enableTSP,
    });
  };

  enableMergeRoutes = (enable) => {
    this.setState({
      enableMergeRoutes: enable,
    });
  };

  toggleRouteAnimation = (stack) => {
    this.setState(
      {
        isRouteAnimationEnabled: !this.state.isRouteAnimationEnabled,
      },
      () => {
        this.props.stack.layoutManager.eventHub.emit(
          "routeAnimation",
          this.state.isRouteAnimationEnabled
        );
        const userProfile = this.props.userData.userProfile;
        const eventSpecificData = {
          autoZoomEnabled: this.state.isRouteAnimationEnabled,
        };
        trackEvent("AutoZoom", userProfile, eventSpecificData);
      }
    );
  };

  toggleMapLegend = (stack) => {
    this.setState(
      {
        isMapLegendEnabled: !this.state.isMapLegendEnabled,
      },
      () => {
        this.props.stack.layoutManager.eventHub.emit(
          "mapLegend",
          this.state.isMapLegendEnabled
        );
      }
    );
  };

  disableEditSave = (isSaveButtonDisabled) => {
    this.setState({
      isSaveButtonDisabled,
    });
  };

  toggleMaximise = (stack) => {
    stack.toggleMaximise();
    this.setState({
      isMaximised: stack.isMaximised,
    });
    const freshDeskContainer = document.getElementById("freshworks-container");
    if (freshDeskContainer && !this.isSubWindow) {
      freshDeskContainer.style.display = stack.isMaximised ? "none" : "block";
    }
    this.props.stack.layoutManager.eventHub.emit("mapResize");
  };
  popOut = (stack) => {
    const quickFilterContent = this.props.stack.parent.getItemsById(
      appConstant.layout.QuickFilter
    );
    let quickFilterContainer = null;
    let quickFilterwidth = null;
    if (quickFilterContent.length) {
      quickFilterContainer = quickFilterContent[0].container;
      quickFilterwidth = quickFilterContainer.width;
    }

    if (stack.layoutManager.isSubWindow) {
      //stack.layoutManager.emit("popIn");
      window?.close();
    } else {
      stack.popout();
      if (quickFilterContainer) {
        quickFilterContainer.setSize(quickFilterwidth);
      }
    }
    const userProfile = this.props.userData.userProfile;
    trackEvent("MultiMonitor", userProfile);
  };

  runTSP = () => {
    if (this.state.enableTSP) {
      this.setState({
        enableTSP: false,
      });
      this.props.stack.layoutManager.eventHub.emit(`${this.headerId}_runTSP`);
    }
  };

  mergeRoutes = () => {
    if (this.state.enableMergeRoutes) {
      this.props.stack.layoutManager.eventHub.emit(
        `${this.headerId}_mergeRoutes`
      );
    }
  };
  onAfterPrint = () => {
    this.props.stack.layoutManager.eventHub.emit("afterPrintEvent");
  };
  onAddEvent = () => {
    this.props.stack.layoutManager.eventHub.emit("addEvent");
  };

  onCreatePickupEvent = () => {
    if (this.state.enableCreatePickup) {
      this.props.stack.layoutManager.eventHub.emit("pickupManagement", {
        action: PICKUP_MANAGEMENT_MODES.CREATE_PICKUP,
      });
    }
  };

  openEquipmentDefectsModel = () => {
    this.props.stack.layoutManager.eventHub.emit(
      "openDriverGridModel",
      "isEquipmentDefectsModalOpen"
    );
  };

  openGroupMessageWindow = () => {
    this.props.stack.layoutManager.eventHub.emit(
      "openDriverGridModel",
      "isDispatchGroupMsgPopupOpen"
    );
  };

  showEditMode = (showEdit) => {
    if (typeof showEdit !== "boolean") {
      showEdit = !this.state.showEditMode;
    }
    if (this.state.enableEdit || !showEdit) {
      this.setState({
        showEditMode: showEdit,
      });
      const columnOptions = this.state.gridApi.columnController
        .getAllGridColumns()
        .filter((col) => col.colDef.editable)
        .map((col) => ({
          label: col.colDef.headerName,
          value: col.colDef.field,
          ...col.colDef,
        }));
      this.setState({
        columnOptions,
        selectedField: columnOptions[0],
        selectedValue:
          this.state.gridApi.getSelectedRows().length === 1
            ? columnOptions[0]
            : "",
      });
    }
  };

  showShipmentComment = () => {
    this.props.stack.layoutManager.eventHub.emit(
      `${this.headerId}_ShowShipmentNote`, {isBulkEdit: true}
    );
  }

  handleChange = (selectedField) => {
    this.setState({
      selectedField,
    });
  };

  saveEdits = (event) => {
    let editorValue = "";
    if (this.editorRef) {
      if (this.editorRef.getValue) {
        editorValue = this.editorRef.getValue();
      } else if (this.editorRef.current) {
        editorValue = this.editorRef.current.value || "";
      }
    }
    this.props.stack.layoutManager.eventHub.emit(
      `${this.headerId}_BulkUpdate`,
      { field: this.state.selectedField.value, newValue: editorValue }
    );
  };

  geocode = () => {
    if (this.state.enableGeocode) {
      this.props.stack.layoutManager.eventHub.emit(`${this.headerId}_geocode`);
    }
  };
  showHidePrint = () => {
    if (this.headerConfig.print) {
      if (this.headerConfig.print.showOnlyInMaximise) {
        return !!this.state.isMaximised;
      } else {
        return true;
      }
    }
  };

  updateprintManifestStatus = (value) => {
    this.setState({
      showPrintLoadingManifest: Boolean(value),
    });
  };

  render() {
    const { classes, stack } = this.props;
    const show = this.state.activeIndex === this.state.headerIndex;
    const showPrint = this.showHidePrint();
    const EditorFramework =
      this.state.selectedField && this.state.selectedField.cellEditorFramework
        ? this.state.selectedField.cellEditorFramework
        : TextFieldEditor;
    return (
      <Fragment>
        <div
          className={`${
            show ? classes.showHeader : classes.hideHeader
          } no-print`}
          ref={this.componentRef}
        >
          {this.state.updateMessage && (
            <div className={classes.updateMessage}>
              <CircularProgress size={14} color="primary" />{" "}
              <span>{this.state.updateMessage}</span>
            </div>
          )}
          {this.state.showEditMode && (
            <Fragment>
              <div
                className={`${classes.editControls} ${classes.showEditMode} ${classes.showControl}`}
              >
                <Select
                  value={this.state.selectedField}
                  onChange={this.handleChange}
                  options={this.state.columnOptions}
                  classNamePrefix={"select"}
                  className={classes.reactSelect}
                  menuPlacement="auto"
                  menuPosition="absolute"
                  closeMenuOnSelect
                  components={{
                    DropdownIndicator: (props) => (
                      <ArrowDropDown
                        {...props.innerProps}
                        className={classes.iconStyle}
                      />
                    ),
                  }}
                />

                <div
                  className={`${classes.inputStyle} ${classes.iconLayout} glHeaderIcons`}
                >
                  <EditorFramework
                    ref={(node) => (this.editorRef = node)}
                    column={{ colDef: this.state.selectedField }}
                  />
                </div>

                <div
                  className={`${classes.headerIconStyles} ${classes.iconLayout} ${classes.headerButtonContainer} glHeaderIcons `}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.buttonDisabled,
                    }}
                    onClick={this.saveEdits}
                    disabled={this.state.isSaveButtonDisabled}
                  >
                    {this.state.isSaveButtonDisabled ? (
                      <CircularProgress size={16} color="primary" />
                    ) : (
                      "Save"
                    )}
                  </Button>
                </div>

                <div
                  className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
                  onClick={this.showEditMode}
                >
                  <CancelIcon color="primary" />
                </div>
              </div>
            </Fragment>
          )}
          <div
            className={
              this.state.showEditMode
                ? classes.hideControl
                : classes.showControl
            }
          >
            {this.headerConfig?.searchBox && (
              <SearchBar 
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}
            <ClearAllFilterButton gridApi={this.state.gridApi} />

            {this.headerConfig?.equipmentDefects && (
              <EquipmentDefects
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                handleClick = {this.openEquipmentDefectsModel}
              />
            )}

            {this.headerConfig?.createDispatch && (
              <CreateDispatch
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                enableDispatchDriver={this.enableDispatchDriver}
              />
            )}

            {this.headerConfig?.endTrip && (
              <EndTripIcon
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}
            {this.headerConfig?.cancelDispatch && (
              <CancelDispatch
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}
            {this.headerConfig?.setAPT && (
              <SetAPT
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}
            {this.headerConfig?.revert && (
              <Revert
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}

            {this.headerConfig?.groupMsg && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
              >
                <Tooltip title="Group Message">
                  <MailOutlineIcon
                    onClick={this.openGroupMessageWindow}
                  />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.geocode && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableGeocode
                    ? classes.enabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.geocode}
              >
                <Tooltip
                  title={
                    this.state.enableGeocode
                      ? "Update location"
                      : "Select a single shipment to update location"
                  }
                >
                  <i className={`icon-geocoding ${classes.actionIcon}`} />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.selectFilter && (
              <div
                className={`${classes.iconLayout} ${classes.pickupsFilterContainer} glHeaderIcons`}
              >
                <PickupsGridFilter
                  headerId={this.headerId}
                  stack={this.props.stack}
                />
              </div>
            )}
            {this.headerConfig?.showShipmentComment && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableEdit
                    ? classes.enabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.state.enableEdit ? this.showShipmentComment: null}
              >
                <Tooltip
                  title={
                    this.state.enableEdit
                      ? "Add shipment note"
                      : "Select a row to add a shipment note"
                  }
                >
                  <EditShipmentNoteIcon />
                </Tooltip>
              </div>
            )}
            {this.headerConfig && this.headerConfig.showEdit && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableEdit
                    ? classes.enabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.showEditMode}
              >
                <Tooltip
                  title={
                    this.state.enableEdit
                      ? "Click to Edit"
                      : "Select a row to edit"
                  }
                >
                  <EditIcon />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.showTSP && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableTSP
                    ? classes.tspEnabledIcon
                    : classes.disableIcon
                }`}
                onClick={this.runTSP}
              >
                <Tooltip
                  title={
                    this.state.enableTSP
                      ? "Run sequence optimizer"
                      : "Select Route to run sequence optimizer"
                  }
                >
                  <TSPIcon />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.showMergeRoutes && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.state.enableMergeRoutes
                    ? classes.enableIcon
                    : classes.disableIcon
                }`}
                onClick={this.state.enableMergeRoutes ? this.mergeRoutes : null}
              >
                <Tooltip title="Merge Routes">
                  <i className={`icon-merge-routes ${classes.actionIcon}`} />
                </Tooltip>
              </div>
            )}

            {this.headerConfig?.showMergeStops && (
              <MergeStops
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}

           {this.headerConfig && this.headerConfig.createPickupControl && (
              <div
                className={`${classes.headerIconStyles} ${
                  classes.iconLayout
                } glHeaderIcons ${
                  this.enablePickupEdit
                    ? classes.enabledIcon
                    : classes.disableIcon
                }`}
                onClick={
                  this.enablePickupEdit ? this.onCreatePickupEvent : null
                }
              >
                <Tooltip
                  title={
                    this.enablePickupEdit
                      ? "Create Pickup"
                      : "Create Pickup (Disabled)"
                  }
                >
                  <AddRoundedIcon />
                </Tooltip>
              </div>
            )}

            {this.headerConfig?.editPickupControl && (
              <EditPickup
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                enableEditPickup={this.enablePickupEdit}
              />
            )}

            {this.headerConfig?.voidPickupControl && (
              <VoidPickup
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
              />
            )}

            {this.headerConfig?.mergePickupControl && (
              <MergePickup
                eventHub={this.props.stack.layoutManager.eventHub}
                headerId={this.props.headerId}
                enableMergePickup = {this.enableMergePickup}
              />
            )}

            {this.headerConfig && this.headerConfig.showHideColumn && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
              >
                <ShowHideColumns
                  api={this.state.gridApi}
                  userData={this.props.userData}
                />
              </div>
            )}
            {this.headerConfig && this.headerConfig.addIcon && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
                onClick={this.onAddEvent}
              >
                <Tooltip title="Add">
                  <AddRoundedIcon />
                </Tooltip>
              </div>
            )}

            {this.headerConfig && this.headerConfig.toggleRouteAnimation && (
              <Tooltip title="Enable/Disable Route Animation">
                <div
                  className={`${classes.toggleAnimationButton} glHeaderIcons`}
                >
                  <div className={classes.toggleText}>
                    {" "}
                    {`${
                      this.state.isRouteAnimationEnabled ? "Disable" : "Enable"
                    } Auto Zoom`}{" "}
                  </div>
                  <ToggleRenderer
                    value={this.state.isRouteAnimationEnabled}
                    onChange={(e) => this.toggleRouteAnimation(stack)}
                  />
                </div>
              </Tooltip>
            )}

            {this.headerConfig && this.headerConfig.toggleMapLegend && (
              <Tooltip title="Enable/Disable Map Legend">
                <div
                  className={`${classes.toggleAnimationButton} glHeaderIcons`}
                >
                  <div className={classes.toggleText}>
                    {" "}
                    {`${
                      this.state.isMapLegendEnabled ? "Disable" : "Enable"
                    } Map Legend`}{" "}
                  </div>
                  <ToggleRenderer
                    value={this.state.isMapLegendEnabled}
                    onChange={(e) => this.toggleMapLegend(stack)}
                  />
                </div>
              </Tooltip>
            )}

            {this.headerConfig && this.headerConfig.mapTools && (
              <MapDrawinToolBox {...this.headerConfig.mapTools} />
            )}

            {this.headerConfig && this.headerConfig.showExportCSV && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${classes.enabledIcon}`}
                onClick={this.exportCSV.bind(this)}
              >
                <Tooltip title="Export Data">
                  <SaveAltSharp />
                </Tooltip>
              </div>
            )}
            {this.headerConfig && showPrint && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
              >
                <PrintMenu
                  stack={this.props.stack}
                  showPrintLoadingManifest={this.state.showPrintLoadingManifest}
                  featureFlags={this.props.featureFlags.featureFlags}
                  onAfterPrint={this.onAfterPrint}
                />
              </div>
            )}

            <div
              className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
              onClick={(e) => this.toggleMaximise(stack)}
            >
              <Tooltip title={this.state.isMaximised ? "Minimize" : "Maximize"}>
                {this.state.isMaximised ? <MinimiseIcon /> : <MaximiseIcon />}
              </Tooltip>
            </div>
            {this.headerConfig && this.headerConfig.showPopout && (
              <div
                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
                onClick={(e) => this.popOut(stack)}
                title={this.isSubWindow ? "Pop In" : "Pop Out"}
              >
                {!this.isSubWindow ? <UndockIcon /> : <PopInIcon />}
              </div>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}
export default compose(
  withWidth(),
  withStyles(styles),
  withUserProfile,
  withFeatureFlags
)(GLComponentHeader);
